import { Label as Text, Typography } from "@packages/ds";
import styled from "styled-components";

import {
  ButtonWrapper as ButtonWrapperDefault,
  Button as ButtonDefault
} from "ds/Button";
import LoadingDefault from "ds/PageLoading";
import SelectDS from "ds/Select";

export const FormWrapper = styled.form`
  box-sizing: border-box;
  display: grid;
  grid-template-rows: 1fr max-content;
  background-color: var(--mode-bg-neutral-weakest);
  height: 100%;
`;

export const ScrollContainer = styled.div`
  overflow: scroll;
`;

export const PreGridWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleAndDialogWrapper = styled.div`
  display: inline-grid;
  align-items: center;
  gap: 6px;
  grid-template-columns: max-content max-content;
`;

export const Title = styled(Typography.Title)`
  margin: 0px !important;
`;

export const VendorIconWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  margin-top: 45px;
  height: 32px;

  a {
    background-color: unset;
    &:hover {
      background-color: unset;
    }
  }
`;

export const ProjectWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin: 0 auto;
`;

export const ContentWrapper = styled.div`
  display: grid;
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;

  @media (max-width: 525px) {
    display: flex;
    flex-direction: column;
  }
`;

export const ConfigureResourcesTitle = styled(Typography.Title)`
  margin: 24px auto 40px auto;

  @media (max-width: 400px) {
    text-align: center;
  }
`;

export const ConfigureResourcesDescription = styled(Typography.BodyText)`
  margin: 0 auto;
  text-align: center;
`;

export const IndentedBodyText = styled(Typography.BodyText)<{ left?: string }>`
  margin: auto 0;
  padding-left: ${({ left }) => (left ? left : `16px`)};
`;

export const IndentedText = styled(Text)`
  padding-left: 16px;
  margin-bottom: unset;
`;

export const Line = styled.hr<{ hideLast?: boolean }>`
  background-color: var(--mode-border-neutral-weakest);
  margin: 12px 0px;

  &:last-of-type {
    ${({ hideLast }) => hideLast && `display: none;`}
  }
`;

export const Label = styled(Typography.Label)`
  margin-top: auto;
`;

export const ButtonWrapper = styled(ButtonWrapperDefault)`
  margin-top: 0px;
  justify-content: center;
`;

export const NoResourcesText = styled(Typography.BodyText)`
  margin: 0 auto;
`;

export const ResourceTypeText = styled(Typography.BodyText)`
  display: inline;
`;

export const Footer = styled.div`
  padding: 20px 32px 32px;
  gap: 16px;
  display: grid;
  justify-content: center;
  margin-bottom: auto;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Loading = styled(LoadingDefault)`
  padding-top: unset;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ClearBtnSpacer = styled.div`
  height: 32px;
`;

export const PricingButton = styled(ButtonDefault)`
  font-size: 13px;
  font-weight: 600;
`;

export const EnvironmentSelectWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  margin-top: 40px;

  @media (max-width: 525px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const EnvironmentLoadingWrapper = styled.div`
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;

  @media (max-width: 400px) {
    width: calc(100vw - 80px);
  }
`;

export const Select = styled(SelectDS)`
  width: 264px;
`;

export const LoadingSpacer = styled.div`
  width: 24px;
`;
